import { render } from "./supporter-criteria-panel.vue?vue&type=template&id=0dd1c3ea&scoped=true&ts=true"
import script from "./supporter-criteria-panel.vue?vue&type=script&lang=ts"
export * from "./supporter-criteria-panel.vue?vue&type=script&lang=ts"

import "./supporter-criteria-panel.vue?vue&type=style&index=0&id=0dd1c3ea&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd1c3ea"]])

export default __exports__